export default __webpack_public_path__ + "static/media/phone.eaa80f78.png";